// extracted by mini-css-extract-plugin
export default {"wrapper":"lt-z","response":"mt-z","error":"nt-z","disabled":"ot-z","buttons":"pt-z","feedbackQuestionSection":"qt-z","yesNoWrapper":"rt-z"};